import {
  ESCALATE_FOR_PEER_TO_PEER,
  ESCALATE_FOR_XSOLIS_PEER_TO_PEER,
  INITIAL,
  PEER_TO_PEER,
  STATUS_DETERMINATION,
} from '../../../PatientWorkQueueTable.constants';

export const determineReviewTypeDesc = (
  value: string,
  isXsolisUser: boolean
) => {
  if (value === STATUS_DETERMINATION) {
    return INITIAL;
  }

  if (value === PEER_TO_PEER) {
    return isXsolisUser
      ? ESCALATE_FOR_XSOLIS_PEER_TO_PEER
      : ESCALATE_FOR_PEER_TO_PEER;
  }

  return value;
};
